import allowedDevices from './allowedDevices';
export default allowedDevices;



// WEBPACK FOOTER //
// ./src/services/allowedDevices/index.js